import { CellphoneLinkOffIcon } from './CellphoneLinkOffIcon';

/**
 * author: Google
 * id 7E4265ED-151D-45CE-BDD2-08B6028B6006
 * name cellphone-link-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-link-off.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const PhonelinkOffIcon = CellphoneLinkOffIcon;
export default PhonelinkOffIcon